export default "__VITE_ASSET__246167ce__"